module.exports = __webpack_public_path__ + "img/jx_logo_b.af0a4d38.png";